<template>
    <div class="spaced-container">
        <!-- Page Content Wrapper -->
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button type="submit" v-on:click="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
                </div>
                <div class="admin-page-content">
                    <div class="forms-container">
                        <table class="table custom-table jsmartable">
                            <thead>
                                <tr>
                                    <th class="" width="40%">
                                        Notification Type :
                                        <div class="form-email-manager required">*</div>
                                    </th>
                                    <th class="" width="40%">
                                        Customer :
                                        <div class="form-email-manager required">*</div>
                                    </th>
                                    <th class="" width="40%">
                                        To Email :
                                        <div class="form-email-manager required">*</div>
                                    </th>
                                    <th class="" width="40%">CC Email :</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(formEmailManager, index) in formEmailManagerData.content" :key="index">
                                    <!--Notification Type-->
                                    <td class="" width="40%">
                                        <v-select v-model="notificationType[formEmailManager.id]"
                                                name="notificationType"
                                                id="notificationType"
                                                label="text"
                                                :options="notificationTypeArr"
                                                :clearable=false
                                                :searchable="false"
                                                @input="notificationTypeError[formEmailManager.id] = ''"
                                                placeholder="Select Notification Type">
                                        </v-select>
                                        <span class="help is-danger">{{notificationTypeError[formEmailManager.id]}}</span>
                                    </td>
                                    <!--Customer-->
                                    <td class="" width="40%">
                                        <v-select v-model="customerId[formEmailManager.id]"
                                                name="customerId"
                                                id="customerId"
                                                label="text"
                                                :filterable="true"
                                                :options="customerArr"
                                                :clearable=false
                                                @input="customerError[formEmailManager.id] = ''"
                                                placeholder="Select Customer">
                                        </v-select>
                                        <span class="help is-danger">{{customerError[formEmailManager.id]}}</span>
                                    </td>
                                    <!-- To Email -->
                                    <td class="" width="40%">
                                        <vue-tags-input
                                            v-model="toEmail[formEmailManager.id]"
                                            :tags="toEmailTagsArr[formEmailManager.id]"
                                            :validation="validation"
                                            @tags-changed="newTags => toEmailTagsArr[formEmailManager.id] = newTags"
                                            @before-adding-tag="checkToEmailTag($event, [formEmailManager.id])"
                                            placeholder=""
                                            @input="toEmailError[formEmailManager.id] = ''"
                                        />
                                        <span class="help is-danger">{{toEmailError[formEmailManager.id]}}</span>
                                    </td>
                                    <!-- CC Email -->
                                    <td class="" width="40%">
                                        <vue-tags-input
                                            v-model="ccEmail[formEmailManager.id]"
                                            :tags="ccEmailTagsArr[formEmailManager.id]"
                                            :validation="validation"
                                            @tags-changed="newTags => ccEmailTagsArr[formEmailManager.id] = newTags"
                                            @before-adding-tag="checkCCEmailTag($event, [formEmailManager.id])"
                                            placeholder=""
                                            @input="ccEmailError[formEmailManager.id] = ''"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="button-demo">
                            <input id="addMultipleFormEmailManagerBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="addMultipleFormEmailManager()">
                            <input id="cancelBtn" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="buttonBack()">
                        </div>
                    </div>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
        <!-- Page Content Wrapper -->
    </div>
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import { commonMixins } from "../../mixins/commonMixins";
    import EventBus from ".././event-bus";
    import {HTTP} from '../../http-common.js';
    import NoAccessPage from "../NoAccessPermission";
    import VueTagsInput from '@johmun/vue-tags-input';
    import vSelect from 'vue-select';

    export default {
        name: 'MultyAddUpdateFormEmailManager',
        components: {
            'app-footer': Footer,
            'no-access': NoAccessPage,
            VueTagsInput,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                pageTitle: "Edit Multiple Form Email Manager",
                selectedID: 0,
                formEmailManagerData : [],

                customerId: [],
                customerArr: [],
                customerError: [],
                notificationType: [],
                notificationTypeArr: [
                    {
                        text: 'Audit Close Notification',
                        value: 'Audit Close Notification'
                    },
                    {
                        text: 'Audit not Perform',
                        value: 'Audit not Perform'
                    },
                    {
                        text: 'Backorder Parts Notification',
                        value: 'Backorder Parts Notification'
                    },
                    {
                        text: 'Held-Ticket not available',
                        value: 'Held-Ticket not available'
                    },
                    {
                        text: 'Part Usage Notification',
                        value: 'Part Usage Notification'
                    },
                    {
                        text: 'Pending PO Parts Notification',
                        value: 'Pending PO Parts Notification'
                    },
                ],
                notificationTypeError: [],
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                toEmail: [],
                toEmailTagsArr: [],
                isValidToEmailTag: true,
                toEmailError: [],
                ccEmail: [],
                ccEmailTagsArr: [],
                isValidCCEmailTag: true,
                ccEmailError: [],

                buttonNames: {
                    save: 'Save',
                    cancel: 'Cancel'
                },
                disableButtons: {
                    save: false,
                    cancel: false
                },
            }
        },
        beforeMount() {
            self = this;
            EventBus.$emit("menu-selection-changed", "ListFormEmailManager");
        },
        mounted: function () {
            self.buttonNames.save = "Update";
            self.selectedID = localStorage.getItem("changeSelectData");
            if (self.selectedID.length <= 0) {
                self.buttonBack();
            } else {
                $("#alertError").hide();
                self.getAllPermissions();
                self.getAllCustomer();
                self.getData();
            }

        },
        methods: {
            buttonBack : function () {
                self.$router.push('/form/email/manager/list');
            },
            getData: function () {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},

                    params: {
                        id: self.selectedID,
                    }
                };
                self.showLoader();
                HTTP.get("/form/email/manager/getmulty", config)
                        .then(function (data) {
                            self.hideLoader();
                            if (data.status == 200) {
                                self.formEmailManagerData = data.data;
                                $.each(self.formEmailManagerData.content, function (i) {
                                    if (self.formEmailManagerData.content[i].id != null) {
                                        if (self.formEmailManagerData.content[i].customer_id != null && typeof self.formEmailManagerData.content[i].customer_id != "undefined" && self.formEmailManagerData.content[i].customer_id != '') {
                                            self.customerId[self.formEmailManagerData.content[i].id] = {text: self.formEmailManagerData.content[i].customerName, value: self.formEmailManagerData.content[i].customer_id};
                                        }

                                        if (self.formEmailManagerData.content[i].notification_type != null && typeof self.formEmailManagerData.content[i].notification_type != "undefined" && self.formEmailManagerData.content[i].notification_type != '') {
                                            self.notificationType[self.formEmailManagerData.content[i].id] = {text: self.formEmailManagerData.content[i].notification_type, value: self.formEmailManagerData.content[i].notification_type};
                                        }

                                        if (self.formEmailManagerData.content[i].to_email && self.formEmailManagerData.content[i].to_email != null && typeof self.formEmailManagerData.content[i].to_email != "undefined" && self.formEmailManagerData.content[i].to_email != '') {
                                            var toEmailArr = self.formEmailManagerData.content[i].to_email.split(",");
                                            let toArray = [];
                                            for(var index = 0; index < toEmailArr.length; index++) {
                                                toArray.push({"text": toEmailArr[index], "tiClasses": ["ti-valid"]});
                                            }
                                            self.toEmailTagsArr[self.formEmailManagerData.content[i].id] = toArray;
                                        }

                                        if (self.formEmailManagerData.content[i].cc_email && self.formEmailManagerData.content[i].cc_email != null && typeof self.formEmailManagerData.content[i].cc_email != "undefined" && self.formEmailManagerData.content[i].cc_email != '') {
                                            var ccEmailArr = self.formEmailManagerData.content[i].cc_email.split(",");
                                            let ccArray = [];
                                            for(var index = 0; index < ccEmailArr.length; index++) {
                                                ccArray.push({"text": ccEmailArr[index], "tiClasses": ["ti-valid"]});
                                            }
                                            self.ccEmailTagsArr[self.formEmailManagerData.content[i].id] = ccArray;
                                        }
                                    }
                                });
                            }
                        })
                        .catch(function (error) {
                            self.hideLoader();
                            self.catchHandler(error, function () {});
                        })
            },
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            checkToEmailTag: function(obj,id) {
                self.toEmailError = [];
                self.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidToEmailTag = false;
                    self.toEmailError[id] = "Please enter valid Email";
                } else obj.addTag();
            },
            checkCCEmailTag: function(obj,id) {
                self.ccEmailError = [];
                self.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError[id] = "Please enter valid Email";
                } else obj.addTag();
            },
            checkForm: function() {
                var checked = true;
                self.customerError = [];
                self.notificationTypeError = [];
                self.toEmailError = [];

                $.each(self.formEmailManagerData.content, function (i) {
                    if(self.formEmailManagerData.content[i].id != null){
                        if (typeof(self.customerId[self.formEmailManagerData.content[i].id])  == 'undefined' || self.customerId[self.formEmailManagerData.content[i].id] == null || self.customerId[self.formEmailManagerData.content[i].id] == '') {
                            self.customerError[self.formEmailManagerData.content[i].id] = "Select Customer";
                            if (checked) {
                                checked = false;
                            }
                        }

                        if (typeof(self.notificationType[self.formEmailManagerData.content[i].id])  == 'undefined' || self.notificationType[self.formEmailManagerData.content[i].id] == null || self.notificationType[self.formEmailManagerData.content[i].id] == '') {
                            self.notificationTypeError[self.formEmailManagerData.content[i].id] = "Select Notification Type";
                            if (checked) {
                                checked = false;
                            }
                        }
                        
                        if (typeof(self.toEmailTagsArr[self.formEmailManagerData.content[i].id]) == 'undefined' || self.toEmailTagsArr[self.formEmailManagerData.content[i].id] == null || self.toEmailTagsArr[self.formEmailManagerData.content[i].id] == '') {
                            self.isValidToEmailTag = false;
                            self.toEmailError[self.formEmailManagerData.content[i].id] = "Please enter email";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                });

                return checked;
            },
            returnData: function () {
                var data = [];
                var customerId = "";
                var notificationType = "";
                $.each(self.formEmailManagerData.content, function (i) {
                    var toEmailData = "";
                    var ccEmailData = "";
                    if (self.formEmailManagerData.content[i].id != null) {

                        if (self.customerId[self.formEmailManagerData.content[i].id] == null || !self.customerId[self.formEmailManagerData.content[i].id].value) {
                            customerId = "";
                        } else {
                            customerId = self.customerId[self.formEmailManagerData.content[i].id].value;
                        }

                        if (self.notificationType[self.formEmailManagerData.content[i].id] == null || !self.notificationType[self.formEmailManagerData.content[i].id].value) {
                            notificationType = "";
                        } else {
                            notificationType = self.notificationType[self.formEmailManagerData.content[i].id].value;
                        }

                        if(self.toEmailTagsArr[self.formEmailManagerData.content[i].id] && self.toEmailTagsArr[self.formEmailManagerData.content[i].id].length > 0) {
                            for(var index = 0;index<self.toEmailTagsArr[self.formEmailManagerData.content[i].id].length;index++) {
                                if(!toEmailData.includes(self.toEmailTagsArr[self.formEmailManagerData.content[i].id][index].text)) {
                                    toEmailData += (self.toEmailTagsArr[self.formEmailManagerData.content[i].id][index].text) + ',';
                                }
                            }
                            toEmailData = toEmailData.replace(/,\s*$/, "");
                        }

                        if(self.ccEmailTagsArr[self.formEmailManagerData.content[i].id] && self.ccEmailTagsArr[self.formEmailManagerData.content[i].id].length > 0) {
                            for(var index = 0;index<self.ccEmailTagsArr[self.formEmailManagerData.content[i].id].length;index++) {
                                if(!ccEmailData.includes(self.ccEmailTagsArr[self.formEmailManagerData.content[i].id][index].text)) {
                                    ccEmailData += (self.ccEmailTagsArr[self.formEmailManagerData.content[i].id][index].text) + ',';
                                }
                            }
                            ccEmailData = ccEmailData.replace(/,\s*$/, "");
                        }

                        var temp = {
                            'id': self.formEmailManagerData.content[i].id,
                            'customer_id' : customerId,
                            'notification_type': notificationType,
                            'to_email': toEmailData,
                            'cc_email': ccEmailData
                        };
                        data.push(temp);
                    }
                });
                var result = {
                    'data' : data
                };
                return result;
            },
            addMultipleFormEmailManager() {
                setTimeout(() => {
                    if (self.isValidCCEmailTag && self.isValidToEmailTag && self.checkForm()) {
                        var config = {
                            headers: {
                                Authorization:localStorage.getItem("access_token")
                            },
                        };
                        var data = self.returnData();
                        self.buttonNames.save = "Updating ...";
                        self.disableButtons.save = true;
                        self.disableButtons.cancel = true;
                        HTTP.post("/form/email/manager/edit/multiple", data, config)
                            .then(function (response) {
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                                self.buttonNames.save = "Update";
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.cancel = true;
                                    self.showSAlert(response.data.message, 'success', false, 3);
                                    
                                    setTimeout(function () {
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        self.buttonBack();
                                    }, 3000);
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br/>";
                                        }
                                        self.showSAlert(err, 'error', false);
                                    }
                                }
                            })
                            .catch(function (err) {
                                self.buttonNames.save = "Update";
                                self.disableButtons.save = false;
                                self.disableButtons.cancel = false;

                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);

            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/FormEmailManagerMaster/MultyAddUpdateFormEmailManager.vue